import React, { createContext, useContext } from 'react'
import { isArray, pick } from 'lodash-es'
import { useStore } from 'zustand'
import shallow from 'zustand/shallow'

// import createContext from 'zustand/context'

// const { Provider, useStore } = createContext()
const Context = createContext()

const useAppStore = (selectors, equalityFn = shallow) => {
  const store = useContext(Context)
  if (store === null) {
    throw new Error('no provider')
  }
  // if (isArray(selectors)) {
  //   const selectedVals = {}
  //   for (let index = 0; index < selectors.length; index++) {
  //     const element = selectors[index]
  //     selectedVals[element] = useStore(store, (x) => x[element], equalityFn)
  //   }
  //   return selectedVals
  // }
  if (isArray(selectors)) {
    return useStore(store, (x) => pick(x, selectors), equalityFn)
  }
  return useStore(store, selectors, equalityFn)
}

const AppStoreProvider = function ({ children, createStore: extendStore }) {
  return <Context.Provider value={extendStore}>{children}</Context.Provider>
}

export { AppStoreProvider, useAppStore }
